var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88236 10.7059C4.88236 7.48976 7.48976 4.88236 10.7059 4.88236C13.9221 4.88236 16.5295 7.48976 16.5295 10.7059C16.5295 13.9221 13.9221 16.5295 10.7059 16.5295C7.48976 16.5295 4.88236 13.9221 4.88236 10.7059ZM10.7059 1C5.3454 1 1 5.3454 1 10.7059C1 16.0664 5.3454 20.4118 10.7059 20.4118C12.6841 20.4118 14.5241 19.8199 16.0584 18.8037L19.6863 22.4314C20.4444 23.1895 21.6733 23.1895 22.4314 22.4314C23.1895 21.6733 23.1895 20.4444 22.4314 19.6863L18.8037 16.0584C19.8199 14.5241 20.4118 12.6841 20.4118 10.7059C20.4118 5.3454 16.0664 1 10.7059 1Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6faebeb23a52e3c01f9de69e6b2124a0.svg";
export { ForwardRef as ReactComponent };